import { useCallback, useEffect, useState } from 'react';

export const useCheckableItems = ({ listItems, defaultItems, multiple = false }) => {
  const [selectedItems, setSelectedItems] = useState(defaultItems ?? []);
  const [checkableItems, setCheckableItems] = useState([]);

  const getSelectedItems = useCallback(() => {
    return selectedItems.map((item) => ({ ...item, checked: !item.nodes?.length }));
  }, [selectedItems]);

  const getItemChildren = useCallback(
    (id, title) => {
      return selectedItems.find((x) => x.id === id || x.title === title)?.nodes;
    },
    [selectedItems],
  );

  const checkItem = useCallback(
    ({ id, title }, nodes = []) => {
      const newItem = { id, title, nodes };
      if (!multiple) {
        setSelectedItems([newItem]);
        return;
      }

      const newItems = [];
      let hasToInsert = true;
      for (const currentItem of selectedItems) {
        if (currentItem.id === newItem.id || currentItem.title === newItem.title) {
          hasToInsert = false;
          newItems.push(newItem);
        } else {
          newItems.push(currentItem);
        }
      }
      if (hasToInsert) newItems.push(newItem);
      setSelectedItems(newItems);
    },
    [selectedItems, multiple],
  );

  const uncheckItem = useCallback(
    (item) => {
      setSelectedItems(selectedItems.filter((x) => x.id !== item.id));
    },
    [selectedItems],
  );

  useEffect(() => {
    const newItems = listItems.map((item) => {
      return {
        ...item,
        checked: selectedItems.some((x) => x.id === item.id || x.title === item.id || x.title === item.title),
      };
    });
    setCheckableItems(newItems);
  }, [listItems, selectedItems]);

  return {
    checkableItems,
    getSelectedItems,
    getItemChildren,
    checkItem,
    uncheckItem,
  };
};
